import { TOUR_TOOLTIP_AREA_ELEMENT_ID } from '@carboncopyco/types';
import { MAX_Z_INDEX, SCREENSHOT_INNER_CONTAINER_ID } from '../constants';

interface CreateAreaElementArgs {
  x: number;
  y: number;
  width?: number;
  height?: number;
  isHidden?: boolean;
  blockPointerEvents?: boolean;
  addBorder?: boolean;
}

/**
 * This function is used to create an area element used in screenshot frames
 */
export const createAreaElement = ({
  x,
  y,
  width,
  height,
  isHidden = false,
  blockPointerEvents = false,
  addBorder = false,
}: CreateAreaElementArgs): HTMLDivElement => {
  const targetElement = document.createElement('div');
  targetElement.id = TOUR_TOOLTIP_AREA_ELEMENT_ID;

  targetElement.style.zIndex = String(MAX_Z_INDEX);
  targetElement.style.position = 'absolute';
  targetElement.style.top = `${y}px`;
  targetElement.style.left = `${x}px`;

  if (!isHidden) {
    targetElement.style.backgroundColor = '#71E5FF4C';
    if (addBorder) {
      targetElement.style.border = '1px solid #71E5FF';
    }
  }

  if (blockPointerEvents) {
    targetElement.style.pointerEvents = 'none';
  }
  //create corners - TODO ENABLE THIS WHEN RESIZING IS SUPPORTED
  // const corners = [
  //   { top: "-3px", bottom: undefined, left: "-3px", right: undefined },
  //   { top: "-3px", bottom: undefined, left: undefined, right: "-3px" },
  //   { top: undefined, bottom: "-3px", left: "-3px", right: undefined },
  //   { top: undefined, bottom: "-3px", left: undefined, right: "-3px" },
  // ]

  // corners.forEach(corner => {
  //   const el = document.createElement("div")
  //   el.style.position = "absolute"
  //   el.style.top = corner?.top
  //   el.style.left = corner?.left
  //   el.style.bottom = corner?.bottom
  //   el.style.right = corner?.right

  //   el.style.position = "absolute"
  //   el.style.backgroundColor = "white"
  //   el.style.border = "1px solid #71E5FF"
  //   el.style.width = "6px"
  //   el.style.height = "6px"

  //   targetElement.appendChild(el)
  // })

  if (width && height) {
    targetElement.style.width = `${width}px`;
    targetElement.style.height = `${height}px`;
  }

  const imageDiv = document.getElementById(SCREENSHOT_INNER_CONTAINER_ID);
  imageDiv?.appendChild(targetElement);

  return targetElement;
};
